<template>
  <div class="content content-full">
    <div class="page-navs bg-white">
      <div class="nav-scroller">
        <div
          class="nav nav-tabs nav-line nav-color-secondary d-flex align-items-center justify-contents-center w-100"
        >
          <span class="nav-link" href="javascript:void(0)">
            Promo Videos <span class="badge-pro badge-primary fw-bold px-2 py-1">PRO</span>
          </span>
        </div>
      </div>
    </div>
    <div class="page-inner">
      <!-- <div class="mt-3 mb-3 text-center" v-if="!user.subscription">
        <ins class="adsbygoogle"
          style="display:block"
          data-ad-client="ca-pub-8326584585992829"
          data-ad-slot="1178271480"
          data-ad-format="auto"
          data-full-width-responsive="true"></ins>
      </div> -->
      <div class="p-5 text-center" v-if="loading">
        <i class="fas fa-spinner fa-spin text-muted"></i>
      </div>

      <!-- <div class="p-3 text-center" v-if="!loading">
        <div>{{ $t('pro_only_feature') }}</div>
        <div class="mt-3 mb-5">
          <router-link to="/upgrade?from=promo-videos" class="btn btn-gradient">
            {{ $t('upgrade_now') }}
          </router-link>
        </div>
        <div class="mt-4 mb-3">
          <a href="https://indiefy-media.s3.us-west-2.amazonaws.com/storyvideos/65689a62b7fcd21e1fbe544c/65689a62b7fcd21e1fbe544c_2.mp4" target="_blank">
            {{ $t('view_example') }}
          </a>
        </div>
      </div> -->

      <div class="card" v-if="!loading && promoVideos.length && !totalReleases">
        <div class="card-body text-center">
          {{ $t('release_published_needed') }}
        </div>
      </div>
      <div class="row" v-if="!loading && promoVideos.length">
        <div class="col-md-3" v-for="item in promoVideos" v-bind:key="item._id">
          <div class="card card-post card-round">
            <a :href="item.story_video" download target="_blank">
              <img class="card-img-top" :src="item.story_preview" :alt="item.title">
            </a>
            <div class="card-body text-center">
              <div class="info-post ml-2">
                <p class="username">{{ item.title }}</p>
                <p class="date text-muted">{{ item.release_title }}</p>
              </div>
              <div class="separator-solid"></div>
              <a @click="trackDownload()" :href="item.story_video" download target="_blank" class="btn btn-primary btn-rounded btn-sm">{{ $t('download') }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body table-responsive p-0" v-if="!loading && pendingVideos.length">
          <table class="table">
            <thead>
              <tr>
                <th>{{ $t('release') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="release in pendingVideos" v-bind:key="release._id">
                <td width="70%">{{ release.title }}</td>
                <td class="text-right">
                  <button v-if="!release.requested" type="button" class="btn btn-sm" @click="requestVideo(release)">
                    {{ $t('request_videos') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import moment from 'moment'
import Distribution from '../services/distributions'

export default {
  name: 'PromoVideos',
  data () {
    return {
      pendingVideos: [],
      totalReleases: [],
      loading: true,
      user: {},
      promoVideos: [],
      moment,
      remainingVideos: 0
    }
  },
  methods: {
    requestVideo: function (release) {
      release.requested = true

      Distribution.requestPromoVideos(release._id).then(() => {
        this.$notify({ message: this.$t('story_videos_requested') }, 'success', 'fa-check')
        this.$forceUpdate()
      })
    },
    trackDownload: function () {
      window.gtag && window.gtag('event', 'Story Video Downloaded', {
        hitType: 'event',
        event_category: 'Promo Videos',
        event_label: 'Story Video Downloaded'
      })
    },
    getPromoVideos: function () {
      Distribution.getAll({ status: [1, 2, 3] }).then(response => {
        this.totalReleases = response.data.length

        this.pendingVideos = _.filter(response.data, item => {
          return (item.status === 2 || item.status === 3) && _.find(item.songs, song => !song.story_video)
        })

        const published = _.filter(response.data, item => item.status === 3 || item.status === 2)

        _.each(published, distro => {
          _.each(distro.songs, song => {
            if (song.story_video) {
              song.release_title = distro.title
              this.promoVideos.push(song)
            }
          })
        })

        this.loading = false
      })
    }
  },
  created: function () {
    this.user = this.$user
    this.getPromoVideos()
  },
  mounted: function () {
    // if (!this.user.subscription) {
    //   (window.adsbygoogle = window.adsbygoogle || []).push({})
    // }
  }
}
</script>

<style scoped>
.pricing-title {
  border: 2px solid white;
  display: inline-block;
  padding: 3px 10px;
  border-radius: 3px;
}

.basic-price {
  font-size: 25px;
}
.pro-price {
  font-size: 45px;
}

.mastering-description {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/PromoVideos.vue